<script>
import { mapGetters } from 'vuex';
import DyteAPI from 'dashboard/api/integrations/dyte';
import JitsiAPI from 'dashboard/api/integrations/jitsi';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    conversationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapGetters({ appIntegrations: 'integrations/getAppIntegrations' }),
    isDyteEnabled() {
      return this.appIntegrations.find(
        integration => integration.id === 'dyte' && !!integration.hooks.length
      );
    },
    isJitsiEnabled() {
      return this.appIntegrations.find(
        integration => integration.id === 'jitsi'
      );
    },
    isVideoIntegrationEnabled() {
      return this.isDyteEnabled || this.isJitsiEnabled;
    },
  },
  mounted() {
    if (!this.appIntegrations.length) {
      this.$store.dispatch('integrations/get');
    }
  },
  methods: {
    async onClick() {
      this.isLoading = true;
      try {
        if (this.isJitsiEnabled) {
          await JitsiAPI.createAMeeting(this.conversationId);
        } else {
          await DyteAPI.createAMeeting(this.conversationId);
        }
      } catch (error) {
        const message = this.isJitsiEnabled
          ? this.$t('INTEGRATION_SETTINGS.JITSI.CREATE_ERROR')
          : this.$t('INTEGRATION_SETTINGS.DYTE.CREATE_ERROR');
        useAlert(message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <NextButton
    v-if="isVideoIntegrationEnabled"
    v-tooltip.top-end="
      isJitsiEnabled
        ? $t('INTEGRATION_SETTINGS.JITSI.START_VIDEO_CALL_HELP_TEXT')
        : $t('INTEGRATION_SETTINGS.DYTE.START_VIDEO_CALL_HELP_TEXT')
    "
    icon="i-ph-video-camera"
    slate
    faded
    sm
    @click="onClick"
  />
</template>
